export default __webpack_public_path__ + "5f54f5a5b7cde1a940e0d8271be2eb06.png";